import controller from './folders.controller';

const template = require('./folders.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folders.component.js